import React from "react";
import "./Toggle.scss";

const Toggle = ({ 
  title, 
  description, 
  checked, 
  onChange, 
  disabled = false,
  color = "#136dec" // Default blue color
}) => {
  const activeStyle = checked && color ? { backgroundColor: color } : {};
  
  return (
    <div className="toggle-item">
      <div className="toggle-info">
        <p className="toggle-title">{title}</p>
        {description && <p className="toggle-description">{description}</p>}
      </div>
      <button
        className={`toggle-switch ${checked ? "active" : ""}`}
        onClick={onChange}
        disabled={disabled}
        type="button"
        style={activeStyle}
      >
        <span className="toggle-slider"></span>
      </button>
    </div>
  );
};

export default Toggle;

